
export default class bodyPlatform
{
    constructor()
    {
        $('body').addClass('browser' + '-' + platform.name.toLowerCase().replace(/\s+/g, '-'));
        $('body').addClass('os' + '-' + platform.os.family.toLowerCase().replace(/\s+/g, '-').replace(/[^a-zA-Z 0-9 -]+/g, ''));
        $('body').addClass('browser-version' + '-' + platform.name.toLowerCase().replace(/\s+/g, '-') + '-' + platform.version.toLowerCase().replace(/\s+/g, '-'))
    }
}
